import axiosInstance from '../utils/axios';
import API_CONFIG from '../config/api.config';

const toIntParam = (value) => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const n = typeof value === 'number' ? value : parseInt(String(value), 10);
  return Number.isNaN(n) ? undefined : n;
};

const getSalesmanItemWiseSales = async ({ startDate, endDate, salesmanId, locationId, categoryId, search }) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const salesmanIdParam = toIntParam(salesmanId);
  if (salesmanIdParam != null) params.salesmanId = salesmanIdParam;

  const locationIdParam = toIntParam(locationId);
  if (locationIdParam != null) params.locationId = locationIdParam;

  const categoryIdParam = toIntParam(categoryId);
  if (categoryIdParam != null) params.categoryId = categoryIdParam;

  if (search && search.trim()) params.search = search.trim();

  const response = await axiosInstance.get(
    `${API_CONFIG.ENDPOINTS.REPORTS}/salesman-item-wise-sales`,
    { params }
  );
  return response.data;
};

export default {
  getSalesmanItemWiseSales,
};
